import { EntityState, EntityStore, QueryEntity, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Course, createCourse } from '../model/course.model';

const initialState: Course = createCourse({});

export interface CourseState extends EntityState<Course> {
}

@StoreConfig({name: 'course'})
export class CourseStore extends EntityStore<CourseState, Course> {
	constructor() {
		super(initialState);
	}
}

@Injectable({providedIn: 'root'})
export class CourseQuery extends QueryEntity<CourseState, Course> {
	constructor(protected store: CourseStore) {
		super(store);
	}
}
